export const TAG_DISCOUNTS_CRUD_FORM_CANCEL = () => ({
    type: 'UI',
    payload: {
        ui_tagDiscountInputBar: {
            status: "",
            meta: {
                title: '',
                button: '',
                type: ''
            },
            payload: null
        }
    }
});
export const TAG_DISCOUNTS_CRUD_FORM_BATCH_EDIT = (payload) => ({
    type: 'UI',
    payload: {
        ui_tagDiscountInputBar: {
            status: "DONE",
            meta: {
                title: 'batch edit',
                button: '',
                type: 'edit'
            },
            payload: payload
        }
    }

});
export const TAG_DISCOUNTS_CRUD_FORM_DONE = (payload) => ({
    type: 'UI',
    payload: {
        ui_tagDiscountInputBar: {
            status: "DONE",
            meta: {
                title: 'edit',
                button: 'save',
                type: 'edit'
            },
            payload: payload
        }
    }
});
export const TAG_DISCOUNTS_CRUD_FORM_DELETE = (payload) => ({
    type: 'UI',
    payload: {
        ui_tagDiscountInputBar: {
            status: "DONE",
            meta: {
                title: 'delete',
                button: 'delete',
                type: 'delete'
            },
            payload: payload
        }
    }
});
export const TAG_DISCOUNTS_DISPLAY_BAR = (payload) => ({
    type: 'UI',
    payload: {
        ui_tagDiscounts: payload
    }
});